import { Dropdown, IDropdownOption } from '@fluentui/react';

import paymentTypes from '../../../../../shared/payment-types.json';
import { Payment } from '../../../slice/newFormReducers';
import { useColumnOnChangeFn, useColumnSelector } from './hooks';

type Props = {
  uuid: string;
};

const key: keyof Payment = "type";

export default ({ uuid }: Props) => {
  const isEditingLocked = useColumnSelector(uuid, "isEditingLocked");
  const value = useColumnSelector(uuid, key);
  const onChange = useColumnOnChangeFn(uuid, key);

  return (
    <Dropdown
      selectedKey={value || ""}
      onChange={onChange}
      options={options}
      disabled={isEditingLocked}
    />
  );
};

const options: IDropdownOption[] = paymentTypes.map((paymentType) => ({
  key: paymentType.type,
  text: paymentType.name,
}));
